import React from 'react'
import { withRouter } from 'react-router-dom'
import { Button } from 'hhsoig-design-system-core'
import { Divider } from '../../components/divider'
import { routePaths } from '../../utilities/routePaths'

export const OpDivStart = ({ history }) => (
  <main className="ds-l-container">
    <div className="ds-l-row ds-u-margin-y--5">
      <div className="ds-l-col--8">
        <h1 className="ds-u-font-size--title ds-u-font-weight--bold">
          Start your complaint
        </h1>
        <p className="ds-u-font-size--lead ds-u-margin-bottom--7">
          This service is for Operating Division partners to submit referrals
          for HHS-OIG hotline operations to review
        </p>
        <Divider />
        <Button
          className="ds-u-margin-top--2"
          variation="primary"
          onClick={() => history.push(routePaths.opdiv.form)}
        >
          Start
        </Button>
      </div>
    </div>
  </main>
)

export default withRouter(OpDivStart)
